import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef, Children } from 'react';
import { useIsMobile } from '../../hooks/useIsMobile.js';
import { ButtonSetProvider } from './context.js';
import { jsx } from '@emotion/react';
import { Flex } from '../Flex/Flex.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '@indeed/ifl-css';

const ButtonSet = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    alignment = "end",
    children,
    orientation = "auto",
    size = "md",
    sx,
    ...remainingProps
  } = props;
  const getIsMobile = orientationProp => {
    if (orientationProp === "vertical") {
      return true;
    } else if (orientationProp === "horizontal") {
      return false;
    } else {
      return "auto";
    }
  };
  const isMobile = useIsMobile(getIsMobile(orientation));
  const context = {
    isVertical: isMobile,
    size
  };
  const childrenArray = isMobile ? Children.toArray(children).slice().reverse() : Children.toArray(children);
  return jsx(ButtonSetProvider, {
    value: context
  }, jsx(Flex, _extends({
    ref: forwardedRef,
    sx: {
      display: "inline-flex",
      flexDirection: isMobile ? "column" : "row",
      flexWrap: "wrap",
      gap: 2,
      inlineSize: "100%",
      justifyContent: alignment === "end" ? "flex-end" : alignment === "center" ? "center" : "flex-start",
      ...sx
    }
  }, remainingProps), childrenArray));
});

export { ButtonSet };
